module.exports = __webpack_public_path__ + "img/f9.54e64a03.jpg";